import React, { useState, useEffect } from "react";
import { Breadcrumb, Button, Form, Input, notification, Progress, Select } from "antd";
import "./work_order_report.css";
import { HiOutlineDocumentCheck } from "react-icons/hi2";

interface WarehouseOption {
    value: string;
    label: string;
}

interface SubmitValues {
    priode_month: string;
    priode_year: string;
    warehouse?: string;
}

const WorkOrderReport: React.FC = () => {
    const [warehouseOptions, setWarehouseOptions] = useState<WarehouseOption[]>([]);
    const [isExporting, setIsExporting] = useState<boolean>(false);

    useEffect(() => {
        const fetchWarehouses = async () => {
            try {
                const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/work-order-report/warehouses`);
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                const data: WarehouseOption[] = await response.json();
                setWarehouseOptions(data);
            } catch (error) {
                console.error("Failed to fetch warehouses:", error);
            }
        };
        fetchWarehouses();
    }, []);
    const transformStyle = {
        transform: "scale(0.80)",
        transformOrigin: "top left",
        width: "125%",
    };
    const Submitbtn = HiOutlineDocumentCheck as React.ComponentType<any>;

    const formatDateCell = (value: any): string => (!value ? "" : String(value).slice(0, 10));
    const handleSubmit = async (values: SubmitValues) => {
        if (!values.priode_month || !values.priode_year) {
            notification.warning({ message: "Priode Month dan Priode Year wajib dipilih.", duration: 5 });
            return;
        }
        setIsExporting(true);
        const notifKey = `export-wo-${Date.now()}`;
        notification.open({
            key: notifKey,
            message: "Export Work Order Report",
            description: <Progress percent={0} size="small" status="active" />,
            duration: 0,
        });
        const startTime = Date.now();
        const progressInterval = setInterval(() => {
            const percent = Math.min(Math.round(((Date.now() - startTime) / 5000) * 100), 100);
            notification.open({
                key: notifKey,
                message: "Export Work Order Report",
                description: <Progress percent={percent} size="small" status="active" />,
                duration: 0,
            });
        }, 200);
        try {
            const [saRes, brandRes] = await Promise.all([
                fetch(`${process.env.REACT_APP_BACKEND_URL}/api/work-order-report/service-advisors`),
                fetch(`${process.env.REACT_APP_BACKEND_URL}/api/work-order-report/brands`),
            ]);
            const saData: WarehouseOption[] = saRes.ok ? await saRes.json() : [];
            const brandData: WarehouseOption[] = brandRes.ok ? await brandRes.json() : [];
            const saMap = new Map<string, string>(saData.map((item) => [String(item.value), item.label]));
            const brandMap = new Map<string, string>(brandData.map((item) => [String(item.value), item.label]));
            const queryParams = new URLSearchParams({
                month: values.priode_month,
                year: values.priode_year,
                warehouse: values.warehouse || "ALL",
            });
            const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/work-order-report/export?${queryParams.toString()}`);
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const rows: Record<string, any>[] = await response.json();
            const elapsed = Date.now() - startTime;
            if (elapsed < 5000) {
                await new Promise((resolve) => setTimeout(resolve, 5000 - elapsed));
            }
            const headers = ["No", "SA", "WE", "WE Date", "WO", "WO Date", "Warehouse", "Chassis", "Engine No", "No Pol", "Bill Name", "Bill Code", "Brand", "Sub Total", "Discount", "Total", "Vat", "Grand Total"];
            const fields = ["service_advisor", "work_estimation_no", "work_estimation_date", "work_order_no", "work_order_date", "warehouse", "chassis_no", "engine_no_detail", "no_polisi", "bill_to_name", "bill_to_code", "brand_detail", "sub_total", "discount", "total", "vat", "grand_total"];
            let tableHtml = '<html xmlns:x="urn:schemas-microsoft-com:office:excel"><head><meta charset="UTF-8" /></head><body><table border="1"><thead><tr>';
            headers.forEach((header) => {
                tableHtml += `<th>${header}</th>`;
            });
            tableHtml += "</tr></thead><tbody>";
            rows.forEach((row, index) => {
                tableHtml += "<tr>";
                tableHtml += `<td>${index + 1}</td>`;
                fields.forEach((field) => {
                    let cellValue = field.endsWith("_date") ? formatDateCell(row[field]) : row[field] ?? "";
                    if (field === "service_advisor") {
                        cellValue = saMap.get(String(row[field] ?? "")) ?? cellValue;
                    }
                    if (field === "brand_detail") {
                        cellValue = brandMap.get(String(row[field] ?? "")) ?? cellValue;
                    }
                    tableHtml += `<td>${cellValue}</td>`;
                });
                tableHtml += "</tr>";
            });
            tableHtml += "</tbody></table></body></html>";
            const fileName = `ExportReportWO${values.priode_month}${values.priode_year}.xls`;
            const blob = new Blob(["\ufeff" + tableHtml], { type: "application/vnd.ms-excel;charset=utf-8" });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
            notification.success({ message: `File ${fileName} berhasil diexport.`, duration: 5 });
        } catch (error) {
            console.error("Failed to export work order report:", error);
            notification.error({ message: `Gagal export Work Order Report: ${(error as Error).message}`, duration: 5 });
        } finally {
            clearInterval(progressInterval);
            notification.destroy(notifKey);
            setIsExporting(false);
        }
    };

    return (
        <div id="ikzk" style={transformStyle}>
            <div className="gjs-grid-row" id="ix6ji">
                <div className="gjs-grid-column" id="i1rni">
                    <Form
                        layout="horizontal"
                        style={{ maxWidth: 350 }}
                        labelCol={{ style: { width: '150px', textAlign: "left" } }}
                        wrapperCol={{ style: { width: '290px' } }}
                        className="custom-info-purchase-request"
                        onFinish={handleSubmit}
                    >
                        <Form.Item
                            label="Priode Month"
                            name="priode_month"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Select
                                placeholder="Select Month"
                                options={[
                                    { value: "01", label: "January" }, { value: "02", label: "February" },
                                    { value: "03", label: "March" }, { value: "04", label: "April" },
                                    { value: "05", label: "May" }, { value: "06", label: "June" },
                                    { value: "07", label: "July" }, { value: "08", label: "August" },
                                    { value: "09", label: "September" }, { value: "10", label: "October" },
                                    { value: "11", label: "November" }, { value: "12", label: "December" },
                                ]}
                                getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
                            />
                        </Form.Item>
                        <Form.Item
                            label="Priode Year"
                            name="priode_year"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Select
                                placeholder="Select Year"
                                options={[
                                    { value: "2026", label: "2026" },
                                    { value: "2027", label: "2027" },
                                    { value: "2028", label: "2028" },
                                ]}
                                getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
                            />
                        </Form.Item>
                        <Form.Item
                            label="Warehouse"
                            name="warehouse"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Select
                                showSearch
                                optionFilterProp="label"
                                style={{ width: "100%" }}
                                popupMatchSelectWidth={false}
                                getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
                                options={[
                                    { value: "ALL", label: "All" },
                                    ...warehouseOptions,
                                ]}
                            />
                        </Form.Item>
                        <Button className="gr-button" htmlType="submit" loading={isExporting}>
                            <Submitbtn style={{ width: '1em', height: '1em', marginRight: '8px' }} />
                            Submit
                        </Button>
                    </Form>

                </div>
            </div>
        </div>
    );
};

export default WorkOrderReport;
